import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "hsl(var(--ink))", color: "hsl(var(--paper))", fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, letterSpacing: "0.15em" }}>
        LOADING…
      </div>
    );
  }

  if (!session) {
    // Preserve the full path including query string so e.g.
    // `/grails?tab=discover` survives the auth round-trip.
    return (
      <Navigate
        to="/auth"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
